import React, { createContext, useReducer } from 'react'
import { LIST } from 'utils/constants'

const DashContext = createContext()

export const actionTypes = {
  SET_DRAWER_COMPONENT: 'SET_DRAWER_COMPONENT'
}

export const initialState = () => ({
  drawerView: {
    view: LIST,
    id: ''
  },
})

const withDashProvider = (Component) =>
  function DashContextWrapper(props) {

    // eslint-disable-next-line react/prop-types
    const [state, dispatch] = useReducer(
      combine(dashReducer),
      initialState({ ...props })
    )
    const createAction = (action) => (payload) =>
      dispatch({ type: action, payload: payload || {} })

    const context = {
      ...state,
      setDrawerView: createAction(actionTypes.SET_DRAWER_COMPONENT)
    }

    return (
      <DashContext.Provider value={context}>
        <Component {...props} />
      </DashContext.Provider>
    )
  }

const combine = (...reducers) => (state, { type, payload }) =>
  reducers.reduce((acc, curr) => curr(acc, { type, payload }), state)

export const dashReducer = (state, { type, payload }) => {
  switch (type) {

    case actionTypes.SET_DRAWER_COMPONENT: {
      return {
        drawerView: {
          ...payload
        }
      }
    }

    default:
      return state
  }
}

export { withDashProvider, DashContext }